module.exports = __webpack_public_path__ + "static/media/PromoIcon.ee2f7ef8.png";